import React, { useState } from 'react';
import './ExpertTalk.css';

const SOURCE_OPTIONS = [
  'Friend / Family Referral',
  'School / College Recommendation',
  'Google Search',
  'Social Media (Instagram / Facebook)',
  'YouTube',
  'LinkedIn',
  'WhatsApp',
  'Newspaper / Magazine',
  'Event / Hackathon',
  'ibots Website',
  'Other',
];

const errStyle = { color: '#e8394d', fontSize: '11px', marginTop: '4px' };

function ExpertTalk({ onClose }) {
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    institution: '', contactPerson: '', phone: '',
    email: '', city: '', eventDate: '',
    participants: '', audience: '', speakerPref: '',
    domain: '', customDomain: '', venue: '', avEquipment: '', brief: '',
    source: '', customSource: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.institution) newErrors.institution = 'Institution name is required';
    if (!formData.contactPerson) newErrors.contactPerson = 'Contact person name is required';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.eventDate) newErrors.eventDate = 'Preferred event date is required';
    if (!formData.participants) newErrors.participants = 'Number of participants is required';
    if (!formData.domain) newErrors.domain = 'Please select a domain';
    if (!formData.source) newErrors.source = 'Please tell us how you heard about ibots';

    if (Object.keys(newErrors).length > 0) {
  setErrors(newErrors);
  setTimeout(() => {
    const firstError = document.querySelector('.error-field');
    if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 100);
  return;
}

    try {
      await fetch('http://localhost:5000/api/enquiry', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          formType: 'expert-talk',
          institution: formData.institution,
          contactPerson: formData.contactPerson,
          phone: formData.phone,
          email: formData.email,
          city: formData.city,
          eventDate: formData.eventDate,
          participants: formData.participants,
          audience: formData.audience,
          speakerPref: formData.speakerPref,
          domain: formData.domain,
          customDomain: formData.customDomain,
          venue: formData.venue,
          avEquipment: formData.avEquipment,
          brief: formData.brief,
          source: formData.source === 'Other' ? formData.customSource : formData.source,
        }),
      });
      try {
        await fetch('http://localhost:5000/api/campus', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
  name:         formData.contactPerson,
  type:         'College',
  phone:        formData.phone,
  email:        formData.email,
  institution:  formData.institution,
  city:         formData.city || '',
  eventDate:    formData.eventDate || '',
  participants: formData.participants || '',
  audience: ({
    'ug1':'UG 1st Year','ug2':'UG 2nd Year','ug3':'UG 3rd Year','ug4':'UG 4th Year',
    'pg1':'PG 1st Year','pg2':'PG 2nd Year',
    'school':'School Students','mixed':'Mixed Audience','faculty':'Faculty',
  }[formData.audience] || formData.audience || ''),
  speakerPref: ({
    'founder':      'iBots Founder — Technology & Entrepreneurship',
    'engineer':     'iBots Senior Engineer — Embedded Systems & IoT',
    'ai':           'iBots AI Specialist — AI & ML',
    'robotics':     'iBots Robotics Expert — Robotics & Automation',
    'drone':        'iBots Drone Specialist — Drone Technology',
    'mechatronics': 'iBots Mechatronics Expert — Industrial Systems',
    'no-pref':      'No Preference — Best suited expert assigned',
  }[formData.speakerPref] || formData.speakerPref || ''),
  domain: formData.domain === 'other' || formData.domain === 'custom' ? formData.customDomain : ({
    'ai':           'Artificial Intelligence & Machine Learning',
    'iot':          'Internet of Things (IoT) & Smart Systems',
    'robotics':     'Robotics & Automation',
    'drone':        'Drone Technology & UAV Applications',
    'electronics':  'Electronics & Embedded Systems',
    'mechatronics': 'Mechatronics & Industrial Automation',
    'stm32':        'STM32 & Embedded Controllers',
    'industry40':   'Industry 4.0 & IIoT',
  }[formData.domain] || formData.domain || ''),
  venue: ({
    'classroom':'Classroom','seminar':'Seminar Hall',
    'auditorium':'Auditorium','lab':'Computer Lab','outdoor':'Outdoor / Open Area',
  }[formData.venue] || formData.venue || ''),
  avEquipment: ({
    'projector':'Projector & Screen','tv':'TV / LED Screen',
    'both':'Both (TV & Projector)','none':'None / Not Available',
  }[formData.avEquipment] || formData.avEquipment || ''),
  brief:        formData.brief || '',
  mode:         'Offline',
  formType:     'Expert Talk',
  source:       formData.source === 'Other' ? formData.customSource : formData.source,
}),
        });
      } catch (err) {
        console.log('Dashboard error:', err);
      }

      setSubmitted(true);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className="et__overlay" onClick={onClose}>
        <div className="et__box" onClick={(e) => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '400px', textAlign: 'center', gap: '16px' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#dcfce7', color: '#16a34a', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900 }}>✓</div>
          <h2 style={{ color: '#0d2e6e', fontWeight: 900, margin: 0 }}>Thank You for Reaching Out to ibots!</h2>
          <p style={{ color: '#64748b', margin: 0, maxWidth: '300px', lineHeight: '1.6' }}>We have received your Expert Talk booking request. Our team will get in touch with you within <strong>24 hours</strong> to confirm the session details.</p>
          <button className="et__submit" onClick={onClose}>Close</button>
        </div>
      </div>
    );
  }

  return (
    <div className="et__overlay" onClick={onClose}>
      <div className="et__box" onClick={(e) => e.stopPropagation()}>

        <button className="et__close" onClick={onClose}>✕ Close</button>
        <h2 className="et__title">Expert / Guest Lecture — Details & Booking</h2>
        <p className="et__subtitle">A focused expert-led knowledge session by an ibots industry professional, tailored to your event and audience.</p>

        <div className="et__stats">
          <div className="et__stat"><p className="et__stat-value">₹10,000</p><p className="et__stat-label">Session Fee / Day</p></div>
          <div className="et__stat"><p className="et__stat-value et__stat-value--blue">1–2 Hours</p><p className="et__stat-label">Session Duration</p></div>
          <div className="et__stat"><p className="et__stat-value et__stat-value--blue">Any Size</p><p className="et__stat-label">Batch Capacity</p></div>
          <div className="et__stat"><p className="et__stat-value et__stat-value--blue">Your Campus</p><p className="et__stat-label">Conducted At</p></div>
        </div>

        <div className="et__two-cols">
          <div className="et__col-card">
            <p className="et__col-title">Expert Talk Covers</p>
            <ul className="et__col-list">
              {['In-depth domain knowledge by industry practitioners','Real-world applications and industry case studies','Career pathways in Electronics, AI & Robotics','Live demonstrations and prototype showcases','Open Q&A with the expert speaker'].map((item, i) => (
                <li key={i}><span className="et__check">✓</span> {item}</li>
              ))}
            </ul>
          </div>
          <div className="et__col-card">
            <p className="et__col-title">Ideal For</p>
            <ul className="et__col-list">
              {['Technical symposiums & department conferences','Annual tech fests and college events','Faculty development programmes (FDP)','Club and association knowledge sessions','Pre-placement awareness programmes'].map((item, i) => (
                <li key={i}><span className="et__arrow">→</span> {item}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="et__logistics">
          <span className="et__logistics-icon">✈️</span>
          <div>
            <p className="et__logistics-title">Logistics Policy — Travel & Accommodation</p>
            <p className="et__logistics-desc">Travel arrangements and accommodation (where applicable) for the ibots expert speaker are the responsibility of the organising institution and are to be arranged and borne entirely by them. These costs are independent of the session fee quoted. Please ensure these are accounted for in your event planning and budget.</p>
          </div>
        </div>

        <h3 className="et__form-title">Book This Session — Requirement Form</h3>

        <div className="et__form">
          <div className="et__row">
            <div className="et__group">
              <label className="et__label">Institution Name *</label>
              <input type="text" name="institution" value={formData.institution}
                onChange={handleChange} placeholder="Enter your institution name" className="et__input" />
              {errors.institution && <p style={errStyle} className="error-field">{errors.institution}</p>}
            </div>
            <div className="et__group">
              <label className="et__label">Contact Person Name *</label>
              <input type="text" name="contactPerson" value={formData.contactPerson}
                onChange={handleChange} placeholder="Name of coordinator / HOD / Principal" className="et__input" />
              {errors.contactPerson && <p style={errStyle} className="error-field">{errors.contactPerson}</p>}
            </div>
          </div>

          <div className="et__row">
            <div className="et__group">
              <label className="et__label">Phone Number *</label>
              <input type="text" name="phone" value={formData.phone}
                onChange={handleChange} placeholder="+91 XXXXX XXXXX" className="et__input" />
              {errors.phone && <p style={errStyle} className="error-field">{errors.phone}</p>}
            </div>
            <div className="et__group">
              <label className="et__label">Email Address *</label>
              <input type="email" name="email" value={formData.email}
                onChange={handleChange} placeholder="official@institution.edu" className="et__input" />
              {errors.email && <p style={errStyle} className="error-field">{errors.email}</p>}
            </div>
          </div>

          <div className="et__row">
            <div className="et__group">
              <label className="et__label">Institution City / Location *</label>
              <input type="text" name="city" value={formData.city}
                onChange={handleChange} placeholder="City, Tamil Nadu" className="et__input" />
              {errors.city && <p style={errStyle} className="error-field">{errors.city}</p>}
            </div>
            <div className="et__group">
              <label className="et__label">Preferred Event Date *</label>
              <input type="text" name="eventDate" value={formData.eventDate}
                onChange={handleChange} placeholder="e.g. 20 July 2025 or July 2025" className="et__input" />
              {errors.eventDate && <p style={errStyle} className="error-field">{errors.eventDate}</p>}
            </div>
          </div>

          <div className="et__row">
            <div className="et__group">
              <label className="et__label">Expected Number of Participants *</label>
              <input type="text" name="participants" value={formData.participants}
                onChange={handleChange} placeholder="e.g. 200 students" className="et__input" />
              {errors.participants && <p style={errStyle} className="error-field">{errors.participants}</p>}
            </div>
            <div className="et__group">
              <label className="et__label">Target Audience</label>
              <select name="audience" value={formData.audience}
                onChange={handleChange} className="et__input et__select">
                <option value="">Select audience...</option>
                <option value="ug1">UG 1st Year</option>
                <option value="ug2">UG 2nd Year</option>
                <option value="ug3">UG 3rd Year</option>
                <option value="ug4">UG 4th Year</option>
                <option value="pg">PG Students</option>
                <option value="faculty">Faculty</option>
                <option value="mixed">Mixed (Students + Faculty)</option>
              </select>
            </div>
          </div>

          <div className="et__speaker-box">
            <p className="et__speaker-title">SPEAKER PREFERENCE (EXPERT TALK SPECIFIC)</p>
            <p className="et__speaker-desc">Please indicate whether you have a specific speaker or domain preference. We will do our best to match the best-suited ibots expert.</p>
          </div>

          <div className="et__row">
            <div className="et__group">
              <label className="et__label">Preferred Speaker / Expert Profile</label>
              <select name="speakerPref" value={formData.speakerPref}
                onChange={handleChange} className="et__input et__select">
                <option value="">Select preference...</option>
                <option value="industry">Industry Professional</option>
                <option value="researcher">Researcher / Academic</option>
                <option value="entrepreneur">Entrepreneur / Startup Founder</option>
                <option value="engineer">Senior Engineer / Technical Lead</option>
                <option value="no-pref">No Preference</option>
              </select>
            </div>
            <div className="et__group">
              <label className="et__label">Primary Domain for the Talk *</label>
              <select name="domain" value={formData.domain}
                onChange={handleChange} className="et__input et__select">
                <option value="">Select domain...</option>
                <option value="women-tech">Women in Technology & STEM Leadership</option>
                <option value="ai-ml">Artificial Intelligence & Machine Learning</option>
                <option value="iot">Internet of Things (IoT) & Smart Systems</option>
                <option value="robotics">Robotics & Automation</option>
                <option value="drone">Drone Technology & UAV Applications</option>
                <option value="electronics">Electronics & Embedded Systems</option>
                <option value="mechatronics">Mechatronics & Industrial Automation</option>
                <option value="entrepreneurship">Entrepreneurship in Deep-Tech / STEM</option>
                <option value="career">Career Pathways in Electronics & Technology</option>
                <option value="custom">Custom / Multiple Domains (specify below)</option>
              </select>
              {errors.domain && <p style={errStyle} className="error-field">{errors.domain}</p>}
              {formData.domain === 'custom' && (
                <input type="text" name="customDomain" value={formData.customDomain}
                  onChange={handleChange} placeholder="Specify your domain combination..."
                  className="et__input et__input--mt" />
              )}
            </div>
          </div>

          <div className="et__row">
            <div className="et__group">
              <label className="et__label">Venue Available</label>
              <select name="venue" value={formData.venue}
                onChange={handleChange} className="et__input et__select">
                <option value="">Select venue type...</option>
                <option value="auditorium">Auditorium</option>
                <option value="seminar">Seminar Hall</option>
                <option value="classroom">Classroom</option>
                <option value="lab">Lab</option>
                <option value="none">None — ibots to arrange</option>
              </select>
            </div>
            <div className="et__group">
              <label className="et__label">AV Equipment Available</label>
              <select name="avEquipment" value={formData.avEquipment}
                onChange={handleChange} className="et__input et__select">
                <option value="">Select...</option>
                <option value="projector">Projector & Screen</option>
                <option value="tv">LED TV / Display</option>
                <option value="both">Both Projector & TV</option>
                <option value="none">None — ibots to arrange</option>
              </select>
            </div>
          </div>

          <div className="et__group et__group--full">
            <label className="et__label">Talk Brief / Custom Requirements</label>
            <textarea name="brief" value={formData.brief} onChange={handleChange}
              placeholder="Describe the purpose of the event, any specific subtopics or focus areas you'd like covered, context about your students, or any other requirements for the expert talk..."
              className="et__input et__textarea" />
          </div>

          <div className="et__group et__group--full">
            <label className="et__label">How did you hear about ibots? *</label>
            <select name="source" value={formData.source}
              onChange={handleChange} className="et__input et__select">
              <option value="">Select...</option>
              {SOURCE_OPTIONS.map((s) => (<option key={s} value={s}>{s}</option>))}
            </select>
            {errors.source && <p style={errStyle} className="error-field">{errors.source}</p>}
            {formData.source === 'Other' && (
              <input type="text" name="customSource" value={formData.customSource}
                onChange={handleChange} placeholder="Please tell us how you found us..."
                className="et__input" style={{ marginTop: '8px' }} />
            )}
          </div>

          <button className="et__submit" onClick={handleSubmit}>
            Submit Booking Request →
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExpertTalk;